import { AxLoading } from "../../../../Limestone/AxLoading/AxLoading";
import { Instance, Props } from "tippy.js";
import { I18nHelper, Translations } from "../../../../Lib/Helper/I18nHelper";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import * as Rental from "../RiderDetailsModule";
import * as models from "../RiderDetailsModelBundle";

export class ProductInfoPortlet {
    private riderDetailsModule: Rental.RiderDetailsModule;

    private loadingGuid: string;
    private axLoading: AxLoading;

    private errorMsgHtmlElement: HTMLElement;
    private portletHtmlElement: HTMLDivElement;
    private nameLabelHtmlElement: HTMLDivElement;
    private mailLabelHtmlElement: HTMLDivElement;
    private activeMarker: HTMLDivElement;

    private addToCartModel: models.ProductAndRiderDetails;

    constructor(element: HTMLDivElement, addToCartModel: models.ProductAndRiderDetails) {
        this.portletHtmlElement = element;
        this.activeMarker = element.parentElement as HTMLDivElement;
        this.errorMsgHtmlElement = this.activeMarker.nextElementSibling as HTMLElement;

        this.addToCartModel = addToCartModel;

        this.riderDetailsModule = AxLoad.GetModule<Rental.RiderDetailsModule>("RiderDetailsModule");

        this.axLoading = new AxLoading();

        this.initLabels();
        this.initOnClickEvent();
    }

    private initOnClickEvent() {
        this.portletHtmlElement.addEventListener('click', x => {
            this.activatePortlet(false);
        });
    }

    private getPortletHtmlElement(): HTMLDivElement {
        return this.portletHtmlElement;
    }

    getProductAndRiderDetails(): models.ProductAndRiderDetails {
        return this.addToCartModel;
    }

    activatePortlet(firstLoad: boolean) {
        this.riderDetailsModule.changeActiveProductPortlet(this, firstLoad);
        this.setPortletActive();
    }

    showPortletLoadingSpinner() {
        this.loadingGuid = this.axLoading.ShowLoadingIndicatorGetId(this.getPortletHtmlElement(), true);
    }

    hidePortletLoadingSpinner() {
        this.axLoading.HideLoadingIndicatorWithId(this.loadingGuid);
    }

    checkFormValidityAndSetStates(): Promise<boolean> {
        let valid = true;

        if (this.addToCartModel?.riderData === undefined || this.addToCartModel?.riderData === null) {
            this.setUserNotSelectedState();
            return Promise.resolve(false);
        }

        if (this.riderDetailsModule.getPersonRentalDataForm().hasForm()) {
            if (this.riderDetailsModule.getPersonRentalDataForm().formIsValid()) {
                this.setUserSelectedState();
                valid = true;
            } else {
                this.setMissingDataState();
                return Promise.resolve(false);
            }
        }

        if (this.riderDetailsModule.lockerIncluded()) {
            const prom = this.riderDetailsModule.getLockerDataComponent().lockerFormIsValid();

            prom.then(asyncValid => {
                if (!asyncValid) {
                    this.setMissingDataState();
                }
            });

            return prom;
        }

        this.setUserSelectedState();
        return Promise.resolve(valid);
    }

    removeUserSelectedState() {
        this.portletHtmlElement.classList.remove('rental_details_rider__product_portlet-user_selected');
    }

    setUserSelectedState() {
        this.portletHtmlElement.classList.add('rental_details_rider__product_portlet-user_selected');
        this.removeUserNotSelectedState();
    }

    removeMissingDataState() {
        this.removeUserNotSelectedState();
    }

    setMissingDataState() {
        const i18nHelper = new I18nHelper();
        this.setUserNotSelectedState(i18nHelper.GetTranslation(Translations.MandatoryRentalDataMissing));
    }

    removeUserNotSelectedState() {
        this.errorMsgHtmlElement.setAttribute('hidden', '');
        this.portletHtmlElement.classList.remove('rental_details_rider__product_portlet-user_not_selected');
    }

    setUserNotSelectedState(text?: string) {
        if (text) {
            this.errorMsgHtmlElement.children[0].innerHTML = text;
        } else {
            const i18nHelper = new I18nHelper();
            this.errorMsgHtmlElement.children[0].innerHTML = i18nHelper.GetTranslation(Translations.RentalNoPersonSelected);
        }

        this.portletHtmlElement.classList.add('rental_details_rider__product_portlet-user_not_selected');
        this.errorMsgHtmlElement.removeAttribute('hidden');
        this.removeUserSelectedState();
    }

    initLabels() {
        this.nameLabelHtmlElement = this.portletHtmlElement.getElementsByClassName('rental_details_rider__product_portlet-person-name')[0] as HTMLDivElement;
        this.mailLabelHtmlElement = this.portletHtmlElement.getElementsByClassName('rental_details_rider__product_portlet-person-mail')[0] as HTMLDivElement;
    }

    updatePersonInfoTexts() {
        this.updateNameText();
        this.updateEmailText();
    }

    private updateNameText() {
        this.nameLabelHtmlElement.innerHTML = this.addToCartModel.riderData.customerName;
    }

    private updateEmailText() {
        this.mailLabelHtmlElement.innerHTML = this.addToCartModel.riderData.customerEmail;
    }

    private setPortletActive() {
        //this.isActive = true;
        this.activeMarker.classList.add('active');
    }

    setPortletInActive() {
        //this.isActive = false;
        this.activeMarker.classList.remove('active');
    }

    setLockerWtpNumberText($parent: JQuery<HTMLElement>, value: string) {
        $('.rental_details_rider__product_portlet-person-wtp', this.portletHtmlElement).removeClass('d-none');

        const intValue = parseInt(value);
        let text = "";

        if (!isNaN(intValue) && intValue < 0) {
            //@ts-ignore
            const instance = $parent[0]._tippy as Instance<Props>;
            text = $('.ax-dropdown__item.selected', $(instance.popper)).html();
        } else {
            text = value;
        }

        $('.rental_details_rider__product_portlet-person-wtp--value', this.portletHtmlElement).html(text);
    }
}